export const getAuthLocation = (withReturnUrl = true) => {
  const retLoc = `${window.location.pathname}${window.location.hash}`;
  const suff = process.env.REACT_APP_ENV === 'prod' ? '' : `-${process.env.REACT_APP_ENV}`;
  const triplemarsURL = `https://auth${suff}.triplemars.com/?redirectUrl=https://console${suff}.triplemars.com${retLoc}`;
  const salefreaksURL = `https://auth${suff}.triplemarsb2b.com/?redirectUrl=https://console${suff}.triplemarsb2b.com${retLoc}`;
  const url = process.env.APP_NAME === 'TRIPLEMARS' ? triplemarsURL : salefreaksURL;
  return withReturnUrl ? url : `https://auth${suff}.triplemars.com/`;
};
